import { z } from 'zod';
import { ID } from '../../utils/codecUtils';
import { PaginationQuery } from '../../utils/listQuery';
import { listResponse } from '../../utils/listResponse';
import { organizationGroupWorkspaceSchema } from '../models/organizationGroupWorkspace.schema';
import { organizationGroupWorkspaceListQuerySchema } from './workspaces.schema';

export type OrganizationGroupWorkspaceListQuery = {
  organization?: ID;
} & PaginationQuery;

export const workspaces = (
  // TODO: organizationGroupId needs to be mandatory here
  baseQuery: OrganizationGroupWorkspaceListQuery & { organizationGroupId?: ID }
) => {
  const { organizationGroupId, ...query } = baseQuery ?? {};
  // Hack for unpaginated query, where all props have to be optional.
  // eslint-disable-next-line no-console
  if (!organizationGroupId) console.warn('No organization group id');

  return {
    endpoint: `/organization_groups/${organizationGroupId}/workspaces`,
    method: 'GET',
    responseSchema: listResponse(organizationGroupWorkspaceSchema),
    query: { ...query, includeTotal: true },
    querySchema: organizationGroupWorkspaceListQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
